"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === "KUBERNETES_DATA") {
    return _extends({}, state, { pods: action.output });
  }

  return state;
};

var initialState = {};
//# sourceMappingURL=kubernetesReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/kubernetes/kubernetesReducer.js
// module id = 250
// module chunks = 0